import React from 'react';
import PropTypes from 'prop-types';
import { Image, Icon } from 'semantic-ui-react';
import Link from '../../../../../lib/components/link';
import huddleIcon from '../../../../../assets/images/huddle-icon.svg';
import styles from './SidebarHeader.styles';
import { GO_HOME } from '../../../../../store/actions/home.types';

const SidebarHeader = ({ closeSidebar }) => (
  <div style={styles.sidebarMenuHeader}>
    <span>
      <Link onClick={closeSidebar}>
        <Image src={huddleIcon} avatar />
      </Link>
      <Icon name="angle right" size="large" />
      <Link action={{ type: GO_HOME }} style={styles.text}>
        HOME
      </Link>
    </span>
    <span style={styles.exit}>
      <Icon link name="remove" size="big" onClick={closeSidebar} />
    </span>
  </div>
);

SidebarHeader.propTypes = {
  closeSidebar: PropTypes.func.isRequired,
};

export default SidebarHeader;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarHeader.js